import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Input,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Form,
    Row,
    Col,
    Spinner,
    Pagination,
    CardFooter,
    Container,
} from "reactstrap";
import { toast } from "react-toastify";
import {
    FaPencilAlt,
    FaTrash,
    FaPlus,
    FaEye,
} from "react-icons/fa";
import { apiURL1 } from "../../config";
import "jspdf-autotable";
import ReactPaginate from "react-paginate";
import axios from "axios";
import Footer from 'components/Footers/Footer';

const CustomTable = ({ columns, data }) => {
    return (
        <Table responsive>
            <thead>
                <tr>
                    {columns &&
                        columns.map((column, index) => <th key={index}>{column}</th>)}
                </tr>
            </thead>
            <tbody>
                {data && data.length > 0 ? (
                    data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((column, colIndex) => (
                                <td key={colIndex}>
                                    {column.toLowerCase() === "actions" ? (
                                        row.actions
                                    ) : column.toLowerCase() === "income" ? (
                                        row.income
                                    ) : column.toLowerCase() === "expense" ? (
                                        row.expense
                                    ) : (
                                        row[column.toLowerCase().replace(/ /g, "")]
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={columns.length} className="text-center">
                            No data available
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

const ExpenseCategory = () => {
    const token = localStorage.getItem("token");

    const [expenseCategories, setExpenseCategories] = useState([]);
    const [newExpenseCategoryName, setNewExpenseCategoryName] = useState("");
    const [editExpenseCategoryId, setEditExpenseCategoryId] = useState(null);
    const [editExpenseCategoryName, setEditExpenseCategoryName] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteExpenseCategoryId, setDeleteExpenseCategoryId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 10;
    const baseURL = apiURL1;
    const [loading, setLoading] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [recordDetails, setRecordDetails] = useState([]);
    const [recordsPage, setRecordsPage] = useState(1);
    const [recordsTotalPages, setRecordsTotalPages] = useState(1);
    const [recordsLimit, setRecordsLimit] = useState(10);
    const [recordsLoading, setRecordsLoading] = useState(false);
    const [recordCategoryName, setRecordCategoryName] = useState('');
    const [recordCategoryId, setRecordCategoryId] = useState(null);

    useEffect(() => {
        fetchExpenseCategories();
    }, [currentPage]);

    const fetchExpenseCategories = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${baseURL}/superadmin/getCategorySummary?page=${currentPage}&limit=${itemsPerPage}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = response.data;
            const categories = data && data.data ? data.data : [];
            const total = data && data.totalPages ? data.totalPages : 1;
            setExpenseCategories(categories || []);
            setTotalPages(total || 1);
        } catch (error) {
            console.error("Error fetching expense categories:", error);
            toast.error("Error fetching expense categories!");
        } finally {
            setLoading(false);
        }
    };

    const handleAddExpenseCategory = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${baseURL}/superadmin/expense-categories`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ name: newExpenseCategoryName }),
            });
            if (response.ok) {
                toast.success("Expense category added successfully!");
                fetchExpenseCategories();
                setNewExpenseCategoryName("");
                setModalOpen(false);
            } else {
                toast.error("Error adding expense category!");
            }
        } catch (error) {
            console.error("Error adding expense category:", error);
            toast.error("Error adding expense category!");
        }
    };

    const handleEditExpenseCategory = (expenseCategory) => {
        setEditExpenseCategoryId(expenseCategory.categoryId);
        setEditExpenseCategoryName(expenseCategory.categoryName);
        setEditModalOpen(true);
    };

    const handleUpdateExpenseCategory = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(
                `${baseURL}/superadmin/expense-categories/${editExpenseCategoryId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ name: editExpenseCategoryName }),
                }
            );
            if (response.ok) {
                toast.success("Expense category updated successfully!");
                fetchExpenseCategories();
                setEditExpenseCategoryId(null);
                setEditExpenseCategoryName("");
                setEditModalOpen(false);
            } else {
                toast.error("Error updating expense category!");
            }
        } catch (error) {
            console.error("Error updating expense category:", error);
            toast.error("Error updating expense category!");
        }
    };

    const handleDeleteExpenseCategory = (id) => {
        setDeleteExpenseCategoryId(id);
        setDeleteModalOpen(true);
    };

    const confirmDeleteExpenseCategory = async () => {
        try {
            const response = await fetch(
                `${baseURL}/superadmin/expense-categories/${deleteExpenseCategoryId}`,
                {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.ok) {
                toast.success("Expense category deleted successfully!");
                fetchExpenseCategories();
            } else {
                toast.error("Error deleting expense category!");
            }
        } catch (error) {
            console.error("Error deleting expense category:", error);
            toast.error("Error deleting expense category!");
        } finally {
            setDeleteModalOpen(false);
            setDeleteExpenseCategoryId(null);
        }
    };

    const filteredExpenseCategories = expenseCategories
        ? expenseCategories.filter((expenseCategory) =>
            expenseCategory.categoryName
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
        )
        : [];

    const handlePageChange = (selectedPage) => {
        setCurrentPage(selectedPage.selected + 1);
    };

    const handleViewRecords = async (categoryId) => {
        setRecordCategoryId(categoryId);
        setRecordsPage(1);
        await fetchCategoryRecords(categoryId, 1);
        setViewModalOpen(true);
    };

    const fetchCategoryRecords = async (categoryId, pageArg) => {
        try {
            setRecordsLoading(true);
            const response = await axios.get(
                `${baseURL}/superadmin/getCategoryRecords/${categoryId}?page=${pageArg || recordsPage}&limit=${recordsLimit}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = response.data;
            setRecordDetails(data && data.data ? data.data : []);
            setRecordCategoryName(data && data.category ? data.category : '');
            setRecordsTotalPages(data && data.totalPages ? data.totalPages : 1);
        } catch (error) {
            console.error('Error fetching category records:', error);
            toast.error('Error fetching category records');
            setRecordDetails([]);
            setRecordsTotalPages(1);
        } finally {
            setRecordsLoading(false);
        }
    };

    const handleRecordsPageChange = async (selectedPage) => {
        const nextPage = selectedPage.selected + 1;
        setRecordsPage(nextPage);
        if (recordCategoryId) {
            await fetchCategoryRecords(recordCategoryId, nextPage);
        }
    };

    const columns = ["Name", "Income", "Expense", "Actions"];

    return (
        <>
            <div
                className="header   d-flex align-items-center"
                style={{
                    minHeight: "600px",
                    backgroundImage:
                        "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                }}
            >
                <span className="mask bg-gradient-default opacity-8" />
                <Container className="d-flex align-items-center" fluid>
                    <Row>
                        <Col lg="7" md="10">
                            <h1 className="display-4 text-white">Expense Categories</h1>
                            <p className="text-white mt-0 mb-5">
                                Manage expense categories for your organization.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">Expense Categories</h3>
                                <div>
                                    <Input
                                        type="text"
                                        placeholder="Search expense categories..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{
                                            marginRight: "10px",
                                            display: "inline-block",
                                            width: "200px",
                                        }}
                                    />
                                    <Button color="primary" size="sm" onClick={() => setModalOpen(true)}>
                                        <FaPlus /> Add New
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {loading ? (
                                    <Spinner />
                                ) : (
                                    <CustomTable
                                        columns={columns}
                                        data={
                                            filteredExpenseCategories
                                                ? filteredExpenseCategories.map((category) => ({
                                                    name: category.categoryName,
                                                    income: category.totalIncome,
                                                    expense: category.totalExpense,
                                                    actions: (
                                                        <>
                                                            {category.categoryName !== 'Student Fee' && category.categoryName !== 'Fund Transfer' && <Button
                                                                color="info"
                                                                size="sm"
                                                                onClick={() =>
                                                                    handleEditExpenseCategory(category)
                                                                }
                                                                style={{ marginRight: "5px" }}
                                                            >
                                                                <FaPencilAlt />
                                                            </Button>}
                                                            {category.categoryName !== 'Student Fee' && category.categoryName !== 'Fund Transfer' && <Button
                                                                color="danger"
                                                                size="sm"
                                                                onClick={() =>
                                                                    handleDeleteExpenseCategory(category.categoryId)
                                                                }
                                                                style={{ marginRight: "5px" }}
                                                            >
                                                                <FaTrash />
                                                            </Button>}
                                                            <Button
                                                                color="primary"
                                                                size="sm"
                                                                onClick={() =>
                                                                    handleViewRecords(category.categoryId)
                                                                }
                                                            >
                                                                <FaEye />
                                                            </Button>
                                                        </>
                                                    ),
                                                }))
                                                : []
                                            }
                                        />
                                )}
                            </CardBody>
                            <CardFooter className="py-4">
                                <nav aria-label="...">
                                    <Pagination
                                        className="pagination justify-content-end mb-0"
                                        listClassName="justify-content-end mb-0"
                                    >
                                        <ReactPaginate
                                            previousLabel={
                                                <i
                                                    className="previous fa fa-chevron-left"
                                                    aria-hidden="true"
                                                ></i>
                                            }
                                            nextLabel={
                                                <i
                                                    className="next fa fa-chevron-right"
                                                    aria-hidden="true"
                                                ></i>
                                            }
                                            breakLabel={"..."}
                                            pageCount={totalPages}
                                            onPageChange={handlePageChange}
                                            containerClassName={"pagination justify-content-end mb-0"}
                                            pageClassName={"page-item"}
                                            pageLinkClassName={"page-link"}
                                            activeClassName={"active"}
                                            previousClassName={"page-item"}
                                            nextClassName={"page-item"}
                                            previousLinkClassName={"page-link"}
                                            nextLinkClassName={"page-link"}
                                        />
                                    </Pagination>
                                </nav>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>
                    Add New Expense Category
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleAddExpenseCategory}>
                        <FormGroup>
                            <Input
                                type="text"
                                placeholder="Enter expense category name"
                                value={newExpenseCategoryName}
                                onChange={(e) => setNewExpenseCategoryName(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Add Expense Category
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(false)}>
                <ModalHeader toggle={() => setEditModalOpen(false)}>
                    Edit Expense Category
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleUpdateExpenseCategory}>
                        <FormGroup>
                            <Input
                                type="text"
                                placeholder="Enter expense category name"
                                value={editExpenseCategoryName}
                                onChange={(e) => setEditExpenseCategoryName(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Update Expense Category
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)}>
                <ModalHeader toggle={() => setDeleteModalOpen(false)}>
                    Delete Expense Category
                </ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this expense category?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={confirmDeleteExpenseCategory}>
                        Yes, Delete
                    </Button>
                    <Button color="secondary" onClick={() => setDeleteModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={viewModalOpen} toggle={() => setViewModalOpen(false)}>
                <ModalHeader toggle={() => setViewModalOpen(false)}>
                    {recordCategoryName ? `${recordCategoryName} Records` : 'Record Details'}
                </ModalHeader>
                <ModalBody>
                    {recordsLoading ? (
                        <Spinner />
                    ) : recordDetails && recordDetails.length > 0 ? (
                        <>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Description</th>
                                        <th>Type</th>
                                        <th>Record Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {recordDetails.map((record) => (
                                        <tr key={record._id}>
                                            <td>
                                                {(() => {
                                                    const d = new Date(record.date);
                                                    const day = String(d.getDate()).padStart(2, '0');
                                                    const month = String(d.getMonth() + 1).padStart(2, '0');
                                                    const year = d.getFullYear();
                                                    return `${day}-${month}-${year}`;
                                                })()}
                                            </td>
                                            <td>{record.amount}</td>
                                            <td>{record.description}</td>
                                            <td>{record.type}</td>
                                            <td>{record.recordType}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end">
                                <Pagination
                                    className="pagination justify-content-end mb-0"
                                    listClassName="justify-content-end mb-0"
                                >
                                    <ReactPaginate
                                        previousLabel={<i className="previous fa fa-chevron-left" aria-hidden="true"></i>}
                                        nextLabel={<i className="next fa fa-chevron-right" aria-hidden="true"></i>}
                                        breakLabel={'...'}
                                        pageCount={recordsTotalPages}
                                        onPageChange={handleRecordsPageChange}
                                        containerClassName={'pagination justify-content-end mb-0'}
                                        pageClassName={'page-item'}
                                        pageLinkClassName={'page-link'}
                                        activeClassName={'active'}
                                        previousClassName={'page-item'}
                                        nextClassName={'page-item'}
                                        previousLinkClassName={'page-link'}
                                        nextLinkClassName={'page-link'}
                                    />
                                </Pagination>
                            </div>
                        </>
                    ) : (
                        <p>No records available.</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setViewModalOpen(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <Footer />
        </>
    );
};

export default ExpenseCategory;
